<template> 
   
  <v-app>
    <v-main> 
      <router-view />
    </v-main>
  </v-app> 
</template>

<script>
//import Main from "./pages/Main";
export default {
  name: "App",
  components: {},created() {
  if (this.$workbox) {
    this.$workbox.addEventListener("waiting", () => {
      this.showUpdateUI = true;
    });
  }
},async accept() {
  this.showUpdateUI = false;
  await this.$workbox.messageSW({ type: "SKIP_WAITING" });
}

};
</script>

<style>
#app {
  font-family: Poppins;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
@font-face {
  font-family: "Poppins";
  src: local("Poppins"),
   url(./fonts/Poppins/Poppins-Regular.ttf) format("truetype");
}
</style>
